import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { toast } from "sonner";

const HERO = "https://images.pexels.com/photos/28893442/pexels-photo-28893442.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Closet created");
      navigate("/wardrobe");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-bg0">
      <div className="flex items-center justify-center p-8 md:p-16 order-2 md:order-1">
        <form onSubmit={submit} className="w-full max-w-md ep-fade-up" data-testid="register-form">
          <div className="overline mb-4 text-volt">Join Eternal</div>
          <h1 className="font-display uppercase text-5xl font-bold tracking-tighter mb-10">Create<br />account.</h1>

          {error && (
            <div className="mb-6 text-sm text-epred border border-epred px-4 py-3" data-testid="register-error">
              {error}
            </div>
          )}

          <label className="overline block mb-3">Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            data-testid="register-name"
            className="w-full bg-transparent border-b-2 border-epborder focus:border-volt px-0 py-3 mb-7 text-white placeholder:text-zinc-600 transition-colors"
            placeholder="Your name"
          />

          <label className="overline block mb-3">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="register-email"
            className="w-full bg-transparent border-b-2 border-epborder focus:border-volt px-0 py-3 mb-7 text-white placeholder:text-zinc-600 transition-colors"
            placeholder="you@example.com"
          />

          <label className="overline block mb-3">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            data-testid="register-password"
            className="w-full bg-transparent border-b-2 border-epborder focus:border-volt px-0 py-3 mb-9 text-white placeholder:text-zinc-600 transition-colors"
            placeholder="min. 6 characters"
          />

          <button
            type="submit"
            disabled={loading}
            data-testid="register-submit"
            className="ep-btn w-full bg-volt text-black py-4 text-sm font-bold uppercase tracking-widest hover:bg-volt-hover disabled:opacity-50"
          >
            {loading ? "Creating…" : "Create Account"}
          </button>

          <p className="text-sm text-epsub mt-8">
            Already have one?{" "}
            <Link to="/login" data-testid="goto-login" className="text-white font-semibold border-b border-volt">
              Sign in
            </Link>
          </p>
        </form>
      </div>

      <div className="hidden md:block relative order-1 md:order-2">
        <img src={HERO} alt="Streetwear" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-l from-black/40 to-black/10" />
      </div>
    </div>
  );
}
